// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-Inputs-AutoSuggest-styles___container--pin0o {
  position: relative;
}

.components-Inputs-AutoSuggest-styles___listItem--kslFg {
  height: auto !important;
  padding-top: 8px;
  padding-bottom: 8px;
  min-height: 18px !important;
}

.components-Inputs-AutoSuggest-styles___location--bR7Zo {
  margin-bottom: 5px;
}

.components-Inputs-AutoSuggest-styles___dropdown--dIJf_ {
  max-width: 736px;
}

.components-Inputs-AutoSuggest-styles___menuItem--_cWhy {
  font-size: 15px;
  color: #1b2432 !important;
  line-height: 18px;
}

.components-Inputs-AutoSuggest-styles___noOptionsMessage--fbVea {
  padding: 8px 16px;
}

.components-Inputs-AutoSuggest-styles___input--OdJdx {
  display: flex !important;
  padding: 0 !important;
}

.components-Inputs-AutoSuggest-styles___placeholder--Ro5Ca {
  position: absolute;
  left: 2px;
  font-size: 16px;
}

.components-Inputs-AutoSuggest-styles___valueContainer--BRK5s {
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  align-items: center;
  overflow: hidden;
  padding: 16px;
}

.components-Inputs-AutoSuggest-styles___valueContainerMulti--ctwsR {
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  align-items: center;
  overflow: hidden;
  padding: 8px;
}

.components-Inputs-AutoSuggest-styles___paper--LJniM {
  position: absolute;
  z-index: 2;
  margintop: 4px;
  left: 0;
  right: 0;
  border-radius: 4px;
}

.components-Inputs-AutoSuggest-styles___iconDrop--U6Z1R {
  color: rgba(0, 0, 0, 0.54);
}

.components-Inputs-AutoSuggest-styles___select--mIeBi div svg {
      top: calc(50% - 8px);
      right: 11px;
      color: rgba(0, 0, 0, 0.54);
      position: absolute;
      pointer-events: none;
      font-size: 18px;
    }

.components-Inputs-AutoSuggest-styles___selectIcon--MZ37P div svg {
      display: none;
    }

.components-Inputs-AutoSuggest-styles___dropdownField--JqTwS div:focus-within > div div:nth-of-type(2) > svg, .components-Inputs-AutoSuggest-styles___dropdownField--JqTwS div:focus > div div:nth-of-type(2) > svg, .components-Inputs-AutoSuggest-styles___dropdownField--JqTwS div:active > div div:nth-of-type(2) > svg {
            transform: rotate(180deg);
          }

.components-Inputs-AutoSuggest-styles___dropdownField--JqTwS p:empty {
  margin-top: 0 !important;
  min-height: 0 !important;
}

.components-Inputs-AutoSuggest-styles___chips--nRhMB {
  display: flex !important;
  flex-wrap: wrap !important;
}

.components-Inputs-AutoSuggest-styles___deleteChipIcon--XSrmt {
  color: #6d717a !important;
  margin-left: 10px !important;
  margin-right: 8px !important;
}

.components-Inputs-AutoSuggest-styles___chip--pnrhz {
  background-color: #edeeef !important;
  border-radius: 4px !important;
  margin: 2px !important;
  color: #1b2432 !important;
  padding: 8px 0 !important;
  font-size: 15px !important;
}

.components-Inputs-AutoSuggest-styles___chip--pnrhz span {
    padding: 0 8px !important;
  }

.components-Inputs-AutoSuggest-styles___selectedMulti--hdMso {
  min-height: 52px;
  height: auto !important;
}

.components-Inputs-AutoSuggest-styles___selectedMulti--hdMso div div:nth-child(2) .components-Inputs-AutoSuggest-styles___iconStyle--kgG6_ {
        transform: rotate(180deg);
        top: calc(50% - 8px);
        right: 11px;
        color: rgba(0, 0, 0, 0.54);
        position: absolute;
        pointer-events: none;
        font-size: 18px;
      }

.components-Inputs-AutoSuggest-styles___selectMulti--fuqFN {
  min-height: 52px;
  height: auto !important;
}

.components-Inputs-AutoSuggest-styles___selectMulti--fuqFN div div:nth-child(2) .components-Inputs-AutoSuggest-styles___iconStyle--kgG6_ {
        top: calc(50% - 8px);
        right: 11px;
        color: rgba(0, 0, 0, 0.54);
        position: absolute;
        pointer-events: none;
        font-size: 18px;
      }

.components-Inputs-AutoSuggest-styles___iconStyle--kgG6_ {
  top: calc(50% - 8px);
  right: 11px;
  color: rgba(0, 0, 0, 0.54);
  pointer-events: none;
  font-size: 18px !important;
  margin-right: 8px;
}

.components-Inputs-AutoSuggest-styles___endText--juzwj p {
  margin-right: 18px;
  font-size: 11px;
  color: #6d717a;
  letter-spacing: 0;
}
`, "",{"version":3,"sources":["webpack://./components/Inputs/AutoSuggest/styles.pcss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,OAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,OAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,OAAO;EACP,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAII;MACE,oBAAoB;MACpB,WAAW;MACX,0BAA0B;MAC1B,kBAAkB;MAClB,oBAAoB;MACpB,eAAe;IACjB;;AAKA;MACE,aAAa;IACf;;AAWM;YACE,yBAAyB;UAC3B;;AAOV;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;AAK5B;;AAHE;IACE,yBAAyB;EAC3B;;AAGF;EACE,gBAAgB;EAChB,uBAAuB;AAczB;;AAXM;QACE,yBAAyB;QACzB,oBAAoB;QACpB,WAAW;QACX,0BAA0B;QAC1B,kBAAkB;QAClB,oBAAoB;QACpB,eAAe;MACjB;;AAKN;EACE,gBAAgB;EAChB,uBAAuB;AAazB;;AAVM;QACE,oBAAoB;QACpB,WAAW;QACX,0BAA0B;QAC1B,kBAAkB;QAClB,oBAAoB;QACpB,eAAe;MACjB;;AAKN;EACE,oBAAoB;EACpB,WAAW;EACX,0BAA0B;EAC1B,oBAAoB;EACpB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".container {\n  position: relative;\n}\n\n.listItem {\n  height: auto !important;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  min-height: 18px !important;\n}\n\n.location {\n  margin-bottom: 5px;\n}\n\n.dropdown {\n  max-width: 736px;\n}\n\n.menuItem {\n  font-size: 15px;\n  color: #1b2432 !important;\n  line-height: 18px;\n}\n\n.noOptionsMessage {\n  padding: 8px 16px;\n}\n\n.input {\n  display: flex !important;\n  padding: 0 !important;\n}\n\n.placeholder {\n  position: absolute;\n  left: 2px;\n  font-size: 16px;\n}\n\n.valueContainer {\n  display: flex;\n  flex-wrap: wrap;\n  flex: 1;\n  align-items: center;\n  overflow: hidden;\n  padding: 16px;\n}\n\n.valueContainerMulti {\n  display: flex;\n  flex-wrap: wrap;\n  flex: 1;\n  align-items: center;\n  overflow: hidden;\n  padding: 8px;\n}\n\n.paper {\n  position: absolute;\n  z-index: 2;\n  margintop: 4px;\n  left: 0;\n  right: 0;\n  border-radius: 4px;\n}\n\n.iconDrop {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.select {\n  div {\n    svg {\n      top: calc(50% - 8px);\n      right: 11px;\n      color: rgba(0, 0, 0, 0.54);\n      position: absolute;\n      pointer-events: none;\n      font-size: 18px;\n    }\n  }\n}\n.selectIcon {\n  div {\n    svg {\n      display: none;\n    }\n  }\n}\n\n.dropdownField {\n  div {\n    &:focus-within,\n    &:focus,\n    &:active {\n      > div {\n        div:nth-of-type(2) {\n          > svg {\n            transform: rotate(180deg);\n          }\n        }\n      }\n    }\n  }\n}\n\n.dropdownField p:empty {\n  margin-top: 0 !important;\n  min-height: 0 !important;\n}\n\n.chips {\n  display: flex !important;\n  flex-wrap: wrap !important;\n}\n\n.deleteChipIcon {\n  color: #6d717a !important;\n  margin-left: 10px !important;\n  margin-right: 8px !important;\n}\n\n.chip {\n  background-color: #edeeef !important;\n  border-radius: 4px !important;\n  margin: 2px !important;\n  color: #1b2432 !important;\n  padding: 8px 0 !important;\n  font-size: 15px !important;\n\n  span {\n    padding: 0 8px !important;\n  }\n}\n\n.selectedMulti {\n  min-height: 52px;\n  height: auto !important;\n  div {\n    div:nth-child(2) {\n      .iconStyle {\n        transform: rotate(180deg);\n        top: calc(50% - 8px);\n        right: 11px;\n        color: rgba(0, 0, 0, 0.54);\n        position: absolute;\n        pointer-events: none;\n        font-size: 18px;\n      }\n    }\n  }\n}\n\n.selectMulti {\n  min-height: 52px;\n  height: auto !important;\n  div {\n    div:nth-child(2) {\n      .iconStyle {\n        top: calc(50% - 8px);\n        right: 11px;\n        color: rgba(0, 0, 0, 0.54);\n        position: absolute;\n        pointer-events: none;\n        font-size: 18px;\n      }\n    }\n  }\n}\n\n.iconStyle {\n  top: calc(50% - 8px);\n  right: 11px;\n  color: rgba(0, 0, 0, 0.54);\n  pointer-events: none;\n  font-size: 18px !important;\n  margin-right: 8px;\n}\n\n.endText p {\n  margin-right: 18px;\n  font-size: 11px;\n  color: #6d717a;\n  letter-spacing: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `components-Inputs-AutoSuggest-styles___container--pin0o`,
	"listItem": `components-Inputs-AutoSuggest-styles___listItem--kslFg`,
	"location": `components-Inputs-AutoSuggest-styles___location--bR7Zo`,
	"dropdown": `components-Inputs-AutoSuggest-styles___dropdown--dIJf_`,
	"menuItem": `components-Inputs-AutoSuggest-styles___menuItem--_cWhy`,
	"noOptionsMessage": `components-Inputs-AutoSuggest-styles___noOptionsMessage--fbVea`,
	"input": `components-Inputs-AutoSuggest-styles___input--OdJdx`,
	"placeholder": `components-Inputs-AutoSuggest-styles___placeholder--Ro5Ca`,
	"valueContainer": `components-Inputs-AutoSuggest-styles___valueContainer--BRK5s`,
	"valueContainerMulti": `components-Inputs-AutoSuggest-styles___valueContainerMulti--ctwsR`,
	"paper": `components-Inputs-AutoSuggest-styles___paper--LJniM`,
	"iconDrop": `components-Inputs-AutoSuggest-styles___iconDrop--U6Z1R`,
	"select": `components-Inputs-AutoSuggest-styles___select--mIeBi`,
	"selectIcon": `components-Inputs-AutoSuggest-styles___selectIcon--MZ37P`,
	"dropdownField": `components-Inputs-AutoSuggest-styles___dropdownField--JqTwS`,
	"chips": `components-Inputs-AutoSuggest-styles___chips--nRhMB`,
	"deleteChipIcon": `components-Inputs-AutoSuggest-styles___deleteChipIcon--XSrmt`,
	"chip": `components-Inputs-AutoSuggest-styles___chip--pnrhz`,
	"selectedMulti": `components-Inputs-AutoSuggest-styles___selectedMulti--hdMso`,
	"iconStyle": `components-Inputs-AutoSuggest-styles___iconStyle--kgG6_`,
	"selectMulti": `components-Inputs-AutoSuggest-styles___selectMulti--fuqFN`,
	"endText": `components-Inputs-AutoSuggest-styles___endText--juzwj`
};
module.exports = ___CSS_LOADER_EXPORT___;
